module.exports = __webpack_public_path__ + "static/media/farmx-logo-white.a10a73b7.png";